<template>
	<div :class="containerClass">
		<app-card
			v-for="(filter, index) in filters"
			:key="filter.propValue"
			class="border-1 border-transparent cursor-pointer"
			:class="{
				'border-1 border-secondary': filter.propValue === modelValue,
				'mt-4': index === 0,
			}"
			:value="modelValue"
			@click="filterByStatus"
			:icon="filter.icon"
			:title="$t(filter.title)"
			:text="filter.text"
			:propValue="filter.propValue"
			:comparison="filter.comparison"
			:creditCardData="filter.creditCardData"
			:price="filter.price"
		/>
	</div>
</template>

<script>
	import AppCard from '@/components/app/AppCard';

	export default {
		name: 'AppGroupCardFilter',
		emits: ['change', 'update:modelValue'],
		props: {
			modelValue: {},
			filters: {},
			statistics: {},
			containerClass: {
				required: false,
				default: 'w-full flex flex-1 flex-wrap',
			},
		},
		components: {
			AppCard,
		},
		methods: {
			filterByStatus(status) {
				if (status !== this.modelValue) {
					this.$emit('update:modelValue', status);
					this.$emit('change', status);
				}
			},
		},
	};
</script>
